.skeleton {
  --ixf-loading-skeleton-background: var(--ixf-color-neutral-lt);
  --ixf-loading-skeleton-border-radius: var(
    --ixf-loading-skeleton-border-radius-override,
    var(--ixf-border-radius-1)
  );
  --ixf-loading-skeleton-line-height: var(
    --ixf-loading-skeleton-line-height,
    var(--ixf-typography-line-height-sm, 1)
  );

  &.fillParent {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @keyframes shimmer {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
    }
  }

  .shape {
    &-rect {
      height: 100%;
      width: 100%;
      border-radius: var(--ixf-loading-skeleton-border-radius);
      display: inline-flex;
      line-height: var(--ixf-loading-skeleton-line-height);
      position: relative;
      overflow: hidden;
      z-index: 1;

      &::after {
        content: " ";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        background: var(--ixf-loading-skeleton-background);
        animation: 2s linear none infinite normal shimmer;
      }
    }

    &-round {
      height: 100%;
      width: 100%;
      border-radius: 50%;
      display: inline-flex;
      line-height: var(--ixf-loading-skeleton-line-height);
      position: relative;
      overflow: hidden;
      z-index: 1;

      &::after {
        content: " ";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        border-radius: 50%;
        background: var(--ixf-loading-skeleton-background);
        animation: 2s linear none infinite normal shimmer;
      }
    }
  }

  .line {
    width: 100%;
    max-width: 100%;
    border-radius: var(--ixf-loading-skeleton-border-radius);
    display: inline-flex;
    line-height: var(--ixf-loading-skeleton-line-height);
    position: relative;
    overflow: hidden;
    z-index: 1;

    &.allowExpand {
      max-width: unset;
    }

    &::after {
      content: " ";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 100%;
      background: var(--ixf-loading-skeleton-background);
      animation: 2s linear none infinite normal shimmer;
    }
  }
}
